import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Bell, CheckCircle, AlertTriangle } from "lucide-react";

const StaticNotice = () => {
  return (
    <Card className="w-full max-w-md border border-white/30 bg-white/20 backdrop-blur-xl shadow-2xl mx-auto relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent rounded-lg"></div>

      <CardHeader className="pb-4 relative z-10">
        <CardTitle className="text-xl md:text-2xl text-gray-900 font-bold drop-shadow-sm flex items-center gap-2">
          <Bell className="h-6 w-6 text-[#19E3E3]" />
          Notice
        </CardTitle>
        <CardDescription className="text-gray-700 text-sm md:text-base font-medium">
          Important update regarding whitelist registration
        </CardDescription>
      </CardHeader>
      
      <CardContent className="px-4 md:px-6 relative z-10 space-y-4">
        <Alert className="border-[#19E3E3]/30 bg-[#19E3E3]/10">
          <AlertTriangle className="h-4 w-4 text-[#19E3E3]" />
          <AlertDescription className="text-gray-800 font-medium">
            To streamline the whitelist registration process, our registration portal has been temporarily closed.
          </AlertDescription>
        </Alert>

        <div className="space-y-3">
          <div className="bg-white/30 backdrop-blur-sm rounded-lg p-4 border border-white/40">
            <div className="flex items-center gap-3 mb-2">
              <CheckCircle className="h-5 w-5 text-green-600" />
              <h3 className="font-semibold text-gray-900">Already registered?</h3>
            </div>
            <p className="text-gray-700 text-sm">
              Your whitelist spot is secure—no further action needed.
            </p>
          </div>

          <div className="bg-white/30 backdrop-blur-sm rounded-lg p-4 border border-white/40">
            <div className="flex items-center gap-3 mb-2">
              <AlertTriangle className="h-5 w-5 text-orange-600" />
              <h3 className="font-semibold text-gray-900">Have a password but didn't register?</h3>
            </div>
            <p className="text-gray-700 text-sm mb-3">
              Please filled out the <a href="https://forms.gle/Er79HPofC2hfyQAt6" target="_blank" rel="noopener noreferrer" className="text-[#19E3E3] hover:underline font-medium">Whitelist Claim Submission Form</a> to get recorded.
            </p>
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
              <p className="text-orange-800 text-sm font-medium">
                ‼️ Warning: Each password can only be used once. Multiple submissions on purpose or share the password to others will result in your whitelist eligibility being revoked.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t border-white/30">
          <p className="text-center text-gray-700 text-sm font-medium">
            Thank you for your understanding and support.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default StaticNotice;